import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_URL;
  const gettingBioLink = async () => {
  const user = JSON.parse(localStorage.getItem('user')) || ''
  const userToken = user?.token
  const userID = user?.userid
  const path = `/api/user/getLink/${userID}/${userToken}`
  const url = baseUrl + path
  const response = await axios.post(url)
  const getLinkresponse = response?.data?.response

  if (getLinkresponse.length > 0) {
    localStorage.setItem('linkData', JSON.stringify(getLinkresponse))
  }
  const linkId = getLinkresponse[0]._id
  localStorage.setItem('linkId', linkId)
  return response.data
}

const openMainScreen = async (username) => {
  const user = JSON.parse(localStorage.getItem('user')) || ''
  const userToken = user?.token
  const userID = user?.userid
  const path = `/api/user/getLink/${username}/${userID}/${userToken}`
  const url = baseUrl + path
  const response = await axios.get(url)
  const getLinkresponse = response?.data?.response
  const linkId = getLinkresponse[0]._id
  localStorage.setItem('linkId', linkId)
  return response
}

const gettingBioLinkService = {
  gettingBioLink,
  openMainScreen,
}

export default gettingBioLinkService
